import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import Fuse from 'fuse.js';
// import SearchSvg from '../UI/searchSvg';
import LocationSvg from '../UI/locationSvg';
import _forEach from 'lodash/forEach';
import _orderBy from 'lodash/orderBy';
import SimpleCalender from '../calender/simple-calender';
// import CalenderAltSvg from '../UI/calendarAltSvg';
import { bindActionCreators } from 'redux';
import { SetAdventureDeparture } from '../../../actions/cart';
// import { ToggleSlidingPanel } from '../../../actions/utils';
import { withApollo } from 'react-apollo'; 
import { GetCityDeparture } from '../../../actions/cities';

class SearchWidget extends PureComponent{

  constructor(props){
    super(props);
 
    this.state = {
      originalSearchList:[],
      searchList:[],
      searchIsOpen:false,
      searchInputValue:"",
      searchDropdownNumber:-1,
      ready:false,
      activeCity:"" //adventure planner
    }

    this.fuse = null;

    
    this.searchbarClicked = this.searchbarClicked.bind(this);
    this.cityClicked = this.cityClicked.bind(this);
    this.documentKeydownHandler = this.documentKeydownHandler.bind(this);
    this.documentClickHandler = this.documentClickHandler.bind(this);
    this.apSearchBarClicked = this.apSearchBarClicked.bind(this);
  }

  documentKeydownHandler(e){
    
    const { searchIsOpen, searchDropdownNumber } = this.state;

    const searchInput = document.querySelectorAll('.search-container .search-results ul li');
    const searchActive = document.querySelector('.search-container .search-results ul li[data-index="'+searchDropdownNumber+'"]');

    if(searchIsOpen){

      //Increment/Decrement cursor position
      if(e.key === 'ArrowDown' && searchDropdownNumber < searchInput.length - 1){
        this.setState({searchDropdownNumber:searchDropdownNumber + 1});
      }
      else if(e.key === 'ArrowUp' && searchDropdownNumber > 0){
        this.setState({searchDropdownNumber:searchDropdownNumber - 1});
      }
      else if(e.key === 'Enter' && searchActive !== null){
        this.cityClicked(searchActive.dataset.name, searchActive.dataset.tourid);
        this.setState({searchIsOpen: false});
      }
    }

  }

  documentClickHandler(e){

    try{
    
      if(this.state.searchIsOpen){  
        if(e.target.offsetParent.className !== "relative mb0" || e.target.offsetParent.className !== "search-results active" || e.target.className !==  "search-result-list-item"){
          setTimeout(() => { 
            this.setState({searchIsOpen:false}); 
          }, 100);
        } 
    
      }   
    }catch(e){}
  }

  async cityClicked(cityName, tourId){
    
    const { /*isTrips,*/ isAdventurePlanner, builderAddGap, /*ToggleSlidingPanel*/ client } = this.props;
    
    /*if(isTrips){
      //Trigger sliding panel (Trips page)
      ToggleSlidingPanel(true, false, false).then(() => {
        document.body.dispatchEvent(new CustomEvent('SEARCH_CITY_CLICK', { detail: tourId }));
      });
    }*/

    if(isAdventurePlanner || builderAddGap){
      //Adventure planner (builder) 
      
      await GetCityDeparture(client, cityName);
      this.setState({activeCity:cityName, searchInputValue:""});

      document.body.dispatchEvent(new CustomEvent('CITY_CLICK', { detail: cityName }));
    }

  }

  componentDidMount(){

    const { /*products,*/ cities, /*isTrips,*/ isAdventurePlanner, builderAddGap, SetAdventureDeparture } = this.props;

    document.body.addEventListener('click', this.documentClickHandler, true);

    /*if(products.length !== 0 && isTrips) this.setupProductList(products);*/
    if(cities !== undefined && (isAdventurePlanner || builderAddGap)) this.setUpCitiesList(cities);

    //adventure planner - clear departure date
    if(isAdventurePlanner || builderAddGap) SetAdventureDeparture("");

    document.body.addEventListener('AP_SEARCHBAR_CLICK', this.apSearchBarClicked);
  }

  componentDidUpdate(prevProp, prevState){

    const { searchDropdownNumber } = this.state;
    const { /*products,*/ /*isTrips,*/ cities, isAdventurePlanner, builderAddGap } = this.props;


    //Search hover state
    if(searchDropdownNumber !== prevState.searchDropdownNumber){
      const searchInputContainer = document.querySelector('.search-container .search-results');
      const searchInput = document.querySelectorAll('.search-container .search-results ul li');
  
      for(let i = 0; i < searchInput.length; i++){
        searchInput[i].classList.remove('hover');
      }

      if(searchInput.length > 0 && searchInput[searchDropdownNumber].dataset.name !== undefined){

        //hover state
        searchInput[searchDropdownNumber].classList.add('hover');

        //scroll container
        searchInputContainer.scrollTop = searchInput[searchDropdownNumber].offsetTop;

      }

    }

    //trips page products
    /*if(products !== prevProp.products && isTrips){
      this.setupProductList(products);
    }*/
    

    //Adventure planner cites
    if(cities !== prevProp.cities && (isAdventurePlanner || builderAddGap)){
      this.setUpCitiesList(cities);
    }

  }

  setUpCitiesList(cities){
  
      //TODO - all popular cities/categories when api ready

      //Save all cities 
      let citiesArr = [];

      const citiesSorted = _orderBy(cities, ['name', 'asc']);

      citiesArr.push({name:'All destinations', type:'title', tourId:""});

      _forEach(citiesSorted, (o) => {citiesArr.push({name:o.name, type:"city", tourId:o.tourId})});


      const originalSearchList = citiesArr;
      const searchList = citiesArr;


      this.setState({originalSearchList:originalSearchList, searchList: searchList});

      //initialise fuse fuzzy search
      this.fuse = new Fuse(originalSearchList, {
        shouldSort: true,
        tokenize: true,
        matchAllTokens: true,
        findAllMatches: true,
        threshold: 0.3,
        location: 0,
        distance: 10,
        maxPatternLength: 32,
        minMatchCharLength: 3,
        keys: ["name"]
      }); 

      //search list ready
      this.setState({ ready:true });

  }

  /*setupProductList(products){

      //TODO - all popular cities/categories/trip style/contineute when api ready


      //Save all cities 
      let citiesArr = [];

      const citiesSorted = _orderBy(products, ['name', 'asc']);

      citiesArr.push({name:'All destinations', type:'title', tourId:""});

      _forEach(citiesSorted, (o) => {citiesArr.push({name:o.name, type:"city", tourId:o.tourId})});


      const originalSearchList = citiesArr;
      const searchList = citiesArr;


      this.setState({originalSearchList:originalSearchList, searchList: searchList});

      //initialise fuse fuzzy search
      this.fuse = new Fuse(originalSearchList, {
        shouldSort: true,
        tokenize: true,
        matchAllTokens: true,
        findAllMatches: true,
        threshold: 0.3,
        location: 0,
        distance: 10,
        maxPatternLength: 32,
        minMatchCharLength: 3,
        keys: ["name"]
      }); 

      //search list ready
      this.setState({ ready:true });
  }*/

  componentWillUnmount(){
    document.body.removeEventListener('click', this.documentClickHandler, true);
    document.body.removeEventListener('AP_SEARCHBAR_CLICK', this.apSearchBarClicked);
    this.fuse = null;
  }

  apSearchBarClicked(){
    this.setState({searchIsOpen: true});
  }

  searchbarClicked(){

    this.setState({searchIsOpen: !this.state.searchIsOpen});
    
    
    //clear active city selection 
    if(this.state.activeCity !== ""){
      this.setState({activeCity : ""});
      document.body.dispatchEvent(new CustomEvent('CITY_CLICK', { detail: "" }));
    }

  }

  searchHandleChange(e){
    this.setState({searchInputValue:e.target.value, searchIsOpen:true});
    this.search(e.target.value);
  }

  renderSearchResultItems(arr, pattern){

    const { originalSearchList } = this.state;

    let searchResultOriginal = [];
    let searchResultItems = [];
    let count = -1;

    //create modify search list
    for (let i = 0; i < arr.length; i++){
      if(arr[i].type !== 'popular' && arr[i].type !== 'title'){
        count++;
        searchResultItems.push(
          <li 
            key={ `${arr[i].name}${Math.random()}` } 
            data-index={count} data-name={arr[i].name} 
            className={`${arr[i].type}`} 
            data-tourid={arr[i].tourId} 
            onClick={ (e)=>{ this.cityClicked(arr[i].name, arr[i].tourId) } }>
              <span className="search-result-list-item">{arr[i].name}</span>
          </li>
        )
      }
    }

    for (let j = 0; j < originalSearchList.length; j++){
      searchResultOriginal.push(
        <li 
          key={ `${originalSearchList[j].name}${Math.random()}` } 
          data-index={j} 
          data-name={originalSearchList[j].name} 
          className={`${originalSearchList[j].type}`} 
          data-tourid={originalSearchList[j].tourId} 
          onClick={ (e)=>{ this.cityClicked(originalSearchList[j].name, originalSearchList[j].tourId) } }>
          <span className="search-result-list-item">{originalSearchList[j].name}</span>
        </li>
      )
    }

    return (pattern === "") ? searchResultOriginal : searchResultItems;

  }

  search(pattern){

    const { ready, originalSearchList } = this.state;

    if(ready){
      const _searchPattern = (pattern === "") ? originalSearchList : this.fuse.search(pattern);
      return <ul id="search-result-list">{this.renderSearchResultItems(_searchPattern, pattern)}</ul>
    }else{
      return <p className="loading-text">Loading...</p>
    }

  }

  render(){
 
    const { isApBus, isAdventurePlanner, builderAddGap, /*products, adventure_departure_date*/ } = this.props;
    const { searchIsOpen, searchInputValue, activeCity } = this.state;
    // const adventurePlannerText = (activeCity !== "") ? activeCity :  'Select your start destination';
    const placeholderText = (isApBus || activeCity === "" ) ? 'Select your start destination' : `${activeCity} - Departure Date`;

    // const _productsNumber = products !== undefined ? products.length : "";

    return (
      <div className={`search-container round-corners px2 ${isApBus ? 'isApBus' : ''} ${isAdventurePlanner ? 'isAdventure' : ''} ${builderAddGap ? 'isAdventure isBuilderGap' : ''} `}>
          
          {/* { isTrips && <p className="white-text mb2 f-size-20"><span className="bold">{_productsNumber} trips</span> <span className="medium">available to book</span></p>} */}

          { isApBus && <h3 className="white-text busabout-h3">Adventure planner</h3> }

          <div className="search-panel mt1" onClick={this.searchbarClicked}>
              <div className="clearfix">
                  <div className="col col-12">
                    <div className="relative mb0">
                      { (isAdventurePlanner || builderAddGap) && <LocationSvg fill="#B1ACA1" /> }

                      <input
                        className={`${activeCity !== "" ? 'active-city' : "" } ${(isAdventurePlanner || builderAddGap) ? 'adventure-planner' : ''}`} 
                        type="search" 
                        id="search-input" 
                        placeholder={placeholderText} 
                        autoComplete="off" 
                        autoCorrect="off" 
                        value={searchInputValue} 
                        onChange={ e => this.searchHandleChange(e) } 
                        onKeyDown={e => this.documentKeydownHandler(e)}/>
        
                        {/* <button type="submit" id="search-button" className={`${isAdventurePlanner ? 'adventure-planner' : ''}`}>
                          { isTrips && <SearchSvg /> }
                          { 
                            isAdventurePlanner && (
                              <>
                              <CalenderAltSvg clazz="mr2" />
                              { adventure_departure_date === "" ? "Departure" : adventure_departure_date } 
                              </>
                            ) 
                          } 
                        </button> */}
                    </div>

            
                  </div>

              </div>
          </div>
     

          <div className="clearfix relative">
              <div className="col col-12">
                <div className={`search-results ${searchIsOpen ? 'active' : ''}`}>
                    { this.search(searchInputValue) }
                </div>
              </div>
          </div>

          { (isAdventurePlanner || builderAddGap) && activeCity !== "" &&  <div className={`search-panel ${isApBus ? 'isApBus' : '' }`}><SimpleCalender isApBus={true} builderAddGap={builderAddGap ? true : false}/></div> }        

      </div>
      )
  }
}


const mapStateToProps = state => {
  return{
    //products:state.products.all,
    cities:state.cities.cities,
    adventure_departure_date:state.cart.adventure_departure_date
  }
}

const mapDispatchToProps = dispatch => {
  return bindActionCreators({
    SetAdventureDeparture,
    //ToggleSlidingPanel
  }, dispatch);
}

export default withApollo(connect(mapStateToProps, mapDispatchToProps)(SearchWidget)); 